import { render, staticRenderFns } from "./HeaderApproval.vue?vue&type=template&id=0c8c7308&lang=pug"
import script from "./HeaderApproval.vue?vue&type=script&lang=js"
export * from "./HeaderApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports